import { render, staticRenderFns } from "./StorePNRStatus.vue?vue&type=template&id=a6749d20&"
import script from "./StorePNRStatus.vue?vue&type=script&lang=js&"
export * from "./StorePNRStatus.vue?vue&type=script&lang=js&"
import style0 from "./StorePNRStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports